
        <div fNodeInput *ngFor="let input of node.inputs" [fInputId]="input" class="left" fOutputConnectableSide="right"
            [fInputMultiple]="node.multiple"></div>
        <div fNodeOutput *ngFor="let output of node.outputs" [fOutputId]="output"  fOutputConnectableSide="right" class="right"
            [fOutputMultiple]="node.multiple"></div>

        <div fResizeHandle [fResizeHandleType]="eResizeHandleType.LEFT_TOP" *ngIf="selectedVersion?.status=='DRAFT'"></div>
        <div fResizeHandle [fResizeHandleType]="eResizeHandleType.RIGHT_TOP" *ngIf="selectedVersion?.status=='DRAFT'"></div>
        <div fResizeHandle [fResizeHandleType]="eResizeHandleType.RIGHT_BOTTOM" *ngIf="selectedVersion?.status=='DRAFT'"></div>
        <div fResizeHandle [fResizeHandleType]="eResizeHandleType.LEFT_BOTTOM" *ngIf="selectedVersion?.status=='DRAFT'"></div>
        
        <mat-icon fDragHandle class="wh-node-toggle-icon-drag" *ngIf="selectedVersion?.status=='DRAFT'">drag_indicator</mat-icon>
        <mat-icon nz-tooltip="{{'worflow.variable.node.tooltip'|translateTA}}" fDragHandle class="wh-node-toggle-icon-variable" *ngIf="this.node.inputParameters?.length > 0">alternate_email</mat-icon>
        <label nz-checkbox class="debug" [(ngModel)]="node.debug" *ngIf="debugging">{{'debug'|translateTA}}</label>
        <mat-icon class="wh-node-icon" *ngIf="!node.svg">{{node.icon}}</mat-icon>
        <mat-icon class="wh-node-icon" *ngIf="node.svg" [svgIcon]="node.icon"></mat-icon>
        <nz-switch [(ngModel)]="node.active" [nzSize]="'small'" class="wh-node-activation"></nz-switch>
            
    
        @let log = getDebuggingLog();
        <div class="wh-node-log" *ngIf="debug && log!=null">
            <nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a" *ngIf="log?.error==false && log?.resultList.length>0" (click)="openResult(log)" />
            <nz-icon nzType="warning" nzTheme="twotone" nzTwotoneColor="#eb4034" *ngIf="log?.error==true"  (click)="openResult(log)"/>
        </div>

        @if(node.parentId){
            <mat-icon class="wh-node-icon-group" [nz-tooltip]="'worflow.grouped'|translateTA:{parentId:node.parentId}">group</mat-icon>
        }

        <div class="node-content">
            <div class="wh-node-title">
               {{node.componentName|translateTA}}
            </div>
        </div>

        <div class="wh-node-name" *ngIf="node.name!=null && node.name!=''">
            <span class="wh-node-name-text">{{node.name}}</span>
        </div>   

        <div class="wh-node-status-group" [ngClass]="{'nodraft':selectedVersion?.status!='DRAFT'}" [style.backgroundColor]="color"></div>